import { create } from 'zustand';
import { listMinistries, Ministry } from '../api/ministries';

interface MinistryStore {
  ministries: Ministry[];
  activeMinistryId: string | null;
  isLoading: boolean;
  error: string | null;

  setActiveMinistry: (ministryId: string | null) => void;
  loadMinistries: () => Promise<void>;
  getActiveMinistry: () => Ministry | null;
  clearError: () => void;
}

export const useMinistryStore = create<MinistryStore>((set, get) => ({
  ministries: [],
  activeMinistryId: localStorage.getItem('activeMinistryId'),
  isLoading: false,
  error: null,

  setActiveMinistry: (ministryId: string | null) => {
    set({ activeMinistryId: ministryId });
    if (ministryId) {
      localStorage.setItem('activeMinistryId', ministryId);
    } else {
      localStorage.removeItem('activeMinistryId');
    }
  },

  loadMinistries: async () => {
    set({ isLoading: true, error: null });
    try {
      const ministries = await listMinistries();
      set({ ministries });

      const state = get();
      if (!state.activeMinistryId && ministries.length > 0) {
        state.setActiveMinistry(ministries[0].id);
      }
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to load ministries';
      set({ error: message });
    } finally {
      set({ isLoading: false });
    }
  },

  getActiveMinistry: () => {
    const state = get();
    if (!state.activeMinistryId) return null;
    return state.ministries.find((m) => m.id === state.activeMinistryId) || null;
  },

  clearError: () => set({ error: null }),
}));
